import { writable } from "../util/customStores";
export const cpuStore = writable();
export const ramStore = writable();
export const symbolTableStore = writable();
export const wiresStore = writable();
export const programExecutionStore = writable();
export const programExecutionLoopStore = writable();
export const messageFeedStore = writable();
